import styles from './introContainer.module.scss';

export default function IntroContainer() {
  return <div className={styles.introContainer} id="introContainer" />;
}
